
import { Component, mixins, State, Watch } from 'nuxt-property-decorator';
import { ThemeName } from '~/store/types';
import SanityDocumentPageMixin from '~/mixins/SanityDocumentPage';
import FilmAboutPage from '~/components/Films/FilmAboutPage.vue';
import ProjectPage from '~/components/Films/ProjectPage.vue';
import WatchVideoPage from '~/components/Sanity/WatchVideoPage.vue';
import TypeformPage from '~/components/Sanity/TypeformPage.vue';
import LiveStreamWatchPage from '~/components/Live/LiveStreamWatchPage.vue';
import SanityDocument from '~/components/Sanity/SanityDocument.vue';
import CustomPage from '~/components/Sanity/CustomPage.vue';
import FullScreenError from '~/components/UIComponents/FullScreenError.vue';
import PromoBoxLandingPage from '~/components/PromoBox/PromoBoxLandingPage.vue';
import { buildSanityRouteMeta } from '~/utils/htmlHead';

@Component({
  head() {
    const c = this as SanityDocumentLandingPage;
    return c.pageState?.data?.seo
      ? buildSanityRouteMeta(c, c.pageState.data.seo)
      : {};
  },
  meta: {
    theme: ThemeName.DARK,
  },
  components: {
    CustomPage,
    FilmAboutPage,
    FullScreenError,
    LiveStreamWatchPage,
    ProjectPage,
    PromoBoxLandingPage,
    SanityDocument,
    TypeformPage,
    WatchVideoPage,
  },
})
export default class SanityDocumentLandingPage extends mixins(
  SanityDocumentPageMixin,
) {
  @State((profile) => profile.user.loggedIn, { namespace: 'profile' })
  loggedIn!: boolean;

  get isLoading() {
    return this.pageState?.isLoading || this.slugState?.isLoading;
  }

  get shouldRedirectToUaPage() {
    if (!this.pageSchema || this.isLandingPageEnabled) {
      return false;
    }

    if (this.isUaPageEnabled) {
      return true;
    }
  }

  get shouldRedirectToCreateAccountPage() {
    if (
      !this.pageSchema ||
      this.isLandingPageEnabled ||
      this.shouldRedirectToUaPage
    ) {
      return false;
    }

    if (this.isCreateAccountPageEnabled && !this.loggedIn) {
      return true;
    }
  }

  @Watch('shouldRedirectToUaPage', { immediate: true })
  handleUaRedirect(current: boolean) {
    if (current === true) {
      this.$router.push(`${this.$route.path.replace(/\/$/, '')}/signup`);
    }
  }

  @Watch('shouldRedirectToCreateAccountPage', { immediate: true })
  handleCreateAccountRedirect(current: boolean) {
    if (current === true) {
      this.$router.push(
        `${this.$route.path.replace(/\/$/, '')}/create-account`,
      );
    }
  }

  @Watch('pageState.hasError', { immediate: true })
  handleErrorChange(current: boolean, previous: boolean) {
    if (current === previous) {
      return;
    }

    if (current && !!this.pageState?.error) {
      const error =
        typeof this.pageState?.error === 'string'
          ? { message: this.pageState?.error }
          : this.pageState?.error;
      this.$nuxt.error(error);
    }
  }
}
